const style = {
  iconStyle: {
    paddingRight: '5px',
    fontSize: '28px',
  },
  size: 'medium',
  variant: 'contained',
  sx: {
    backgroundColor: 'secondary.main',
  },
} as const;

export default style;
